// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hospital-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5 21V9.25L12 3L19 9.22222V21H5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10.0003 16V21H14.0003V16H10.0003Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 10H12M12 10H14M12 10V8M12 10V12M10.0003 21V16H14.0003V21H10.0003Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 9.77653V21H19V9.75M3 11L12 3L21 11","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hospital-1')
export default class Hospital1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hospital-1',
    }
  }
}
